(function () {
  const MOBILE_MAX = 1024; // < 1024px => mobile
  const instances = new Map(); // id -> { swiper, el }

  // Debounce to avoid resize thrash
  function debounce(fn, delay) {
    let t;
    return function () {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, arguments), delay);
    };
  }

  function isMobile() {
    return window.innerWidth <= MOBILE_MAX;
  }

  function initSwiper(el) {
    if (!window.Swiper) {
      console.warn('[featured-blog] Swiper not found. Load it before featured-blog.js');
      return null;
    }
    // Guard: already initialized?
    if (instances.get(el.id)?.swiper) return instances.get(el.id).swiper;

    const paginationEl = el.querySelector('.swiper-pagination');

    const swiper = new Swiper('#' + el.id, {
      wrapperClass: 'swiper-wrapper',
      slideClass: 'swiper-slide',
      slidesPerView: 'auto', // variable width; clamp in CSS to max 340px
      spaceBetween: 16,
      watchOverflow: true,
      centeredSlides: false,
      resistanceRatio: 0.85,
      pagination: paginationEl
        ? { el: paginationEl, clickable: true }
        : undefined,
      a11y: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide'
      }
    });

    instances.set(el.id, { swiper, el });
    return swiper;
  }

  function destroySwiper(el) {
    const ref = instances.get(el.id);
    if (ref?.swiper && typeof ref.swiper.destroy === 'function') {
      ref.swiper.destroy(true, true);
    }
    instances.delete(el.id);
  }

  function mountAll() {
    document.querySelectorAll('.blog__swiper[id^="BlogSwiper-"]').forEach((el) => {
      if (isMobile()) {
        initSwiper(el);
      } else {
        destroySwiper(el);
      }
    });
  }

  // DOM ready
  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  onReady(mountAll);

  // Resize listener
  window.addEventListener('resize', debounce(mountAll, 150));
})();
